import { AxiosInstance } from 'axios';

import { HealthAPIApiFactory } from '@cast/openapi-services';

import { AXIOS_CONFIGURATION } from '../constants';

export const ServicesApiAdapter = (client: AxiosInstance) => {
  const healthGeneratedApi = HealthAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    listHealth: healthGeneratedApi.healthAPIListHealth,
  };
};
